import { TextButton } from "../components/button/Button.tsx";
import { Icon } from "../components/icon/Icon.tsx";
import { isIos } from "../utils/deviceUtil.ts";
import { APP_STORE_URL, PLAY_STORE_URL } from "../constants.ts";
import { useTranslation } from "../state/i18n.tsx";
import Section from "./Section.tsx";

type MobileWelcomeSectionProps = {
  openPlatform: () => void;
};

const MobileWelcomeSection = (props: MobileWelcomeSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section fullHeight centerOnMobile>
      <hgroup class="my-auto py-6 mobile:pt-0 mobile:pb-6">
        <div
          aria-hidden="true"
          class="mx-auto flex size-20 flex-none shrink-0 items-center justify-center rounded-full bg-surface-status-subtle-success mobile:mx-0"
        >
          <Icon name="checkCircle" size="2xl" type="solid" class="icon-status-success" />
        </div>
        <h2 class="mt-4 text-header-xl text-primary">{t(($) => $.MOBILE_WELCOME_PAGE_TITLE)}</h2>
        <p class="mt-1 text-medium-regular text-secondary">{t(($) => $.MOBILE_WELCOME_PAGE_DESCRIPTION)}</p>
      </hgroup>
      <div class="mt-auto flex flex-col gap-y-2">
        <TextButton
          variant="primary"
          text={t(($) => $.MOBILE_WELCOME_PAGE_OPEN_APP_BUTTON_LABEL)}
          onClick={() => window.open(isIos() ? APP_STORE_URL : PLAY_STORE_URL, "_blank")}
        />
        <TextButton
          variant="secondary"
          text={t(($) => $.MOBILE_WELCOME_PAGE_OPEN_PLATFORM_BUTTON_LABEL)}
          onClick={props.openPlatform}
        />
      </div>
    </Section>
  );
};

export default MobileWelcomeSection;
